import { Flex, MinusIcon, PlusIcon } from '@pancakeswap/uikit'
import Divider from 'components/Divider'
import { DescriptionType } from 'config/FAQ/type'
import { useState } from 'react'
import { CollapseCard, CsIconButton, CsTitle } from '../../../../styled'
import Description from "./Description"

interface Props {
    item: DescriptionType,
    isShowDivider: boolean
}
const Collapse:React.FC<Props> = ({
    item,
    isShowDivider
}) => {
    // ================== VAR ==================
    // ================== STATE ==================
    const [isShow, setIsShow] = useState(false)
    // ================== REDUX ==================
    // ================== FUNCTION ==================
    const handleToggle = () => {
        setIsShow(!isShow)
    }
    // ================== EFFECT ==================
    // ================== RENDER ==================
    // ================== MAIN ==================
    const renderIcon = () => {
        return (
            <CsIconButton scale="sm" onClick={handleToggle}>
                {isShow ? <MinusIcon style={{ cursor: 'pointer' }} /> : <PlusIcon style={{ cursor: 'pointer' }} />}
            </CsIconButton>
        )
    }
    return (
        <CollapseCard isShow={isShow} isShowDivider={isShowDivider}>
            <Flex width="100%" flexDirection="column">
                <Flex width="100%" justifyContent="space-between" alignItems="center">
                    <CsTitle>{item?.title}</CsTitle>
                    {renderIcon()}
                </Flex>
                <Description isShow={isShow} content={item?.content} />
            </Flex>
        </CollapseCard>
    )
}
export default Collapse
